import { render, staticRenderFns } from "./ModifiedDot.vue?vue&type=template&id=86836068&scoped=true&lang=pug&"
import script from "./ModifiedDot.vue?vue&type=script&lang=js&"
export * from "./ModifiedDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86836068",
  null
  
)

/* custom blocks */
import block0 from "@/lang/components/modifiedDot.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fcomponents%2FModifiedDot.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports